import type { AppInfo } from '../types/auth';

export function getAppRedirectUrl(app: AppInfo, token: string): string {
  const lang = localStorage.getItem('language') || 'fr';
  return `${app.redirect_uri}?token=${token}&lang=${lang}`;
}

export function formatDate(date: Date): string {
  return new Date(date).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
